import * as $ from 'jquery';
import { apiBaseUrlUser } from '../../../constants/url.constant';
import { DefaultService } from '../../common/services/DefaultService';
import { UserProductFilterModel, HomePageLinkFilterModel } from '../models/ProductModel';

export class UserProductLineService extends DefaultService {
    private baseUrl = `${apiBaseUrlUser}/productLine`;

    public RouteSearch = () => `${this.baseUrl}/search`;
    public search(model: UserProductFilterModel): JQueryPromise<any> {
        return $.ajax(this.RouteSearch(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteGetListCount = () => `${this.baseUrl}/getListCount`;
    public getListCount(model: UserProductFilterModel): JQueryPromise<any> {
        return $.ajax(this.RouteGetListCount(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteGetFilters = () => `${this.baseUrl}/getFilters`;
    public getFilters(model: HomePageLinkFilterModel): JQueryPromise<any> {
        return $.ajax(this.RouteGetFilters(), {
            type: 'post',
            data: JSON.stringify(model),
            contentType: 'application/json'
        });
    }

    public RouteGetPictures = (ownerId: number) => `${this.baseUrl}/getPictures/${ownerId}`;
    public getPictures(ownerId: number): JQueryPromise<any> {
        return $.ajax(this.RouteGetPictures(ownerId), {
            type: 'get',
            contentType: 'text/html; charset=utf-8'
        });
    }

    public emptyRequest(): JQueryPromise<any> {
        return $.ajax("");
    }
}